/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  UpdateReportingUnitMutationRequest,
  UpdateReportingUnitMutationResponse,
  UpdateReportingUnit400,
} from '../types/UpdateReportingUnit'

function getUpdateReportingUnitUrl() {
  const res = {
    method: 'POST',
    url: `/api/v1/preferences/reporting-unit/update/` as const,
  }
  return res
}

/**
 * @summary Update the reporting unit for the current company
 * {@link /api/v1/preferences/reporting-unit/update/}
 */
export async function updateReportingUnit(
  data: UpdateReportingUnitMutationRequest,
  config: Partial<RequestConfig<UpdateReportingUnitMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateReportingUnitMutationResponse,
    ResponseErrorConfig<UpdateReportingUnit400>,
    UpdateReportingUnitMutationRequest
  >({
    method: 'POST',
    url: getUpdateReportingUnitUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
